export const ubigeoTypes = {
    REGION_RESET: '[Region] RESET',
    REGION_GET_START: '[Region] GET_START',
    REGION_GET_COMPLETE: '[Region] GET_COMPLETE',
    REGION_GET_ERROR: '[Region] GET_ERROR',
    
    PROVINCIA_RESET: '[Provincia] RESET',
    PROVINCIA_GET_START: '[Provincia] GET_START',
    PROVINCIA_GET_COMPLETE: '[Provincia] GET_COMPLETE',
    PROVINCIA_GET_ERROR: '[Provincia] GET_ERROR',
    
    DISTRITO_RESET: '[Distrito] RESET',
    DISTRITO_GET_START: '[Distrito] GET_START',
    DISTRITO_GET_COMPLETE: '[Distrito] GET_COMPLETE',
    DISTRITO_GET_ERROR: '[Distrito] GET_ERROR',

    
    REGION_MUNI_RESET: '[RegionMuni] RESET',
    REGION_MUNI_GET_START: '[RegionMuni] GET_START',
    REGION_MUNI_GET_COMPLETE: '[RegionMuni] GET_COMPLETE',
    REGION_MUNI_GET_ERROR: '[RegionMuni] GET_ERROR',
    
    PROVINCIA_MUNI_RESET: '[ProvinciaMuni] RESET',
    PROVINCIA_MUNI_GET_START: '[ProvinciaMuni] GET_START',
    PROVINCIA_MUNI_GET_COMPLETE: '[ProvinciaMuni] GET_COMPLETE',
    PROVINCIA_MUNI_GET_ERROR: '[ProvinciaMuni] GET_ERROR',
    
    DISTRITO_MUNI_RESET: '[DistritoMuni] RESET',
    DISTRITO_MUNI_GET_START: '[DistritoMuni] GET_START',
    DISTRITO_MUNI_GET_COMPLETE: '[DistritoMuni] GET_COMPLETE',
    DISTRITO_MUNI_GET_ERROR: '[DistritoMuni] GET_ERROR',
}